





























import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import ScheduledFeesDialogForm from '@/components/Products/ProductFees/Scheduled/ScheduledFeesDialogForm.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import UpdateScheduledFeeRequest from '@/models/Products/ProductFees/UpdateScheduledFeeRequest';

@Component({ name: 'ScheduledFeesEditDialog', components: { ScheduledFeesDialogForm } })
export default class extends SaascadaVueDialog {

    dialog = false;
    scheduledFeeRequest: UpdateScheduledFeeRequest = new UpdateScheduledFeeRequest(this.currentScheduledFee);

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.scheduledFeeRequest = new UpdateScheduledFeeRequest(this.currentScheduledFee);
        }
    }

    get currentScheduledFee() {
        return ProductDetailsModule.currentScheduledFee;
    }

    async save() {
        if (!(this.$refs.form as any).validateForm()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.editScheduledFee(this.scheduledFeeRequest);
        }
    }

}
